import { AuthStore } from '~/stores/authStore';
import useStores from '~/utils/useStores';

export const useIsSBSHook = () => {
  const { authStore } = useStores() as { authStore: AuthStore };
  const { currentOrg } = authStore;

  return currentOrg.get('contractOwnerCode') === 'SBS';
};
